// 9fbef606107a605d69c0edbcd8029e5d 
/**
 * These are temporary changes for a dummy login page
 */

const LOGOUT_CONSTANTS = {
  LOGOUT_APP: 'LOGOUT_APP',
};

export default LOGOUT_CONSTANTS;
